module.exports = __webpack_public_path__ + "static/moderni-technologie-pro-retail-audit-0111ac81ff66a334ac5f30149279f738.jpg";